import { useCallback } from 'react';
import type { ElasticVehicle } from '@//app/api/search/vehicles/[id]';
import type { Market } from '@//config/domain-locale-map';
import { useLegacyTracking } from '@//providers/LegacyTrackingProvider';
import { useMarket } from '@//providers/MarketSettingsProvider';
import type { LegacyTrackEquipmentFilterSearchEventData } from './legacy-types';
import { mapElasticVehicleToLegacyItem } from './utils';

interface UseLegacyTrackEquipmentFilterSearchVariables {
  vehicle: ElasticVehicle;
  search: string;
}

export const createLegacyTrackEquipmentFilterSearch = (
  market: Market,
  variables: UseLegacyTrackEquipmentFilterSearchVariables,
): LegacyTrackEquipmentFilterSearchEventData => {
  const eventData: LegacyTrackEquipmentFilterSearchEventData = {
    eventType: 'equipmentFilterSearch',
    item: mapElasticVehicleToLegacyItem(market, variables.vehicle),
    pageType: 'product page',
    search: variables.search,
  };

  return eventData;
};

export const useLegacyTrackEquipmentFilterSearch = () => {
  const market = useMarket();
  const { track } = useLegacyTracking();

  const trackLegacyEquipmentFilterSearch = useCallback(
    (variables: UseLegacyTrackEquipmentFilterSearchVariables) => {
      track({
        event: 'equipmentFilterSearch',
        data: createLegacyTrackEquipmentFilterSearch(market, variables),
      });
    },
    [track],
  );

  return {
    trackLegacyEquipmentFilterSearch,
  };
};
